import config from 'config';

import type { Team } from 'types/team';

export interface TeamFilterOptionFactoryOption {
  sequence?: number;
  id?: number;
  name: string;
  emoji: string | null;
  deleted?: boolean;
}
export interface TeamFilterDropdownOption {
  sequence: number;
  value: number | null;
  name: string;
  image: string | null;
  deleted: boolean;
  groupFilter: 'deleted' | 'active';
}
export const teamFilterOptionFactory = (
  team: TeamFilterOptionFactoryOption
): TeamFilterDropdownOption => ({
  sequence: team.sequence || 0,
  value: team.id ?? null,
  name: team.name,
  image: team.emoji || null,
  deleted: team.deleted || false,
  groupFilter: team.deleted ? 'deleted' : 'active',
});

// Some generic juggling required here. Can't wait til we use TS instead
export const userOnTeamAssociationFactory = <
  A extends {
    large_retina: string;
  },
  U extends {
    id: number;
    name: string;
    avatar: A;
  },
>(
  user: U,
  isTeamLead: boolean
): TeamUser => ({
  id: user.id,
  name: user.name,
  avatar: user.avatar.large_retina || null,
  isTeamLead,
});

interface RegularUser {
  id: number;
  name: string;
  avatar: string | null;
  isTeamLead?: false;
}

interface TeamLeadUser extends Omit<RegularUser, 'isTeamLead'> {
  isTeamLead: true;
  hide_hours?: boolean; // this is used to mark team leads that are not members of a team (but they do manage it)
}

export type TeamUser = RegularUser | TeamLeadUser;

export type TeamWithUsers = Team & {
  teamUsers: Array<TeamUser>;
};
export const teamDraftFactory = (seed?: Partial<TeamWithUsers>): TeamWithUsers => {
  const defaults: TeamWithUsers = {
    name: '',
    emoji: `${config.emojiCdnPath}/${config.defaultTeamEmoji}`,
    users: [],
    teamUsers: [],
  };

  return {
    ...defaults,
    ...seed,
  };
};
